<template>
  <div  class="dnnCloud-login-box">
      
       <!-- 彩色横断面 -->
       <img src="static/img/icon_login_csdm.svg" alt=""  class="icon-dm animate__animated">
       <!-- 紫云基建 -->
       <img src="static/img/icon_login_zyjj.svg" alt=""  class="icon-jyjj animate__animated">
       <!-- 	EICAD4.0 路线专业版 -->
       <img src="static/img/icon_login_erzy.svg" alt=""  class="icon-erzy animate__animated">
       <!--  EICAD4.0 标准版 -->
       <img src="static/img/icon_login_erbz.svg" alt=""  class="icon-erbz animate__animated">
       <!-- EICAD4.0道路专业版 -->
       <img src="static/img/icon_login_erdl.svg" alt=""  class="icon-erdl animate__animated">
       <!-- 	EICAD4.0 路基专业版 -->
       <img src="static/img/icon_login_erlj.svg" alt=""  class="icon-erlj animate__animated">
      
      <el-form :model="loginForm" :rules="rules2" ref="loginForm" label-position="left" label-width="0px" class="login-container">
        <h2 class="title">账号登录</h2>
        <el-form-item prop="phone">
          <span class="iconfont icon-dianhua"></span>
          <el-input class="phone no-autofill" type="text" v-model="loginForm.phone" auto-complete="off"  placeholder="手机号码"></el-input>
        </el-form-item>

        <el-form-item prop="password">
          <span class="iconfont icon-mima"></span>
          <el-input class="phone no-autofill" type="password" v-model="loginForm.password"  auto-complete="off" placeholder="密码"></el-input>
        </el-form-item>

        <el-form-item style="margin-bottom: 0">
          <el-button class="gradual large" type="primary" style="width:100%;"  :loading="loginLoading"  @click.native.prevent="handleSubmit2" data-appid="2014410046" data-cbfn="callback" >登 录</el-button>
          <a class="link" href="http://www.jsdnn.com/" target="_blank">狄诺尼官网</a>
        </el-form-item>
      </el-form>

      <footer class="ftBoxs ft-copyright">
          <p>江苏狄诺尼信息技术有限责任公司</p>
          <p>CopyRight © 2019 Jiangsu Delauney Information Co., Ltd. 苏ICP备18062906</p>
      </footer>
  </div>
</template>

<script>
  import axios from 'axios'
  import { API__code, API__login } from '../api/index.js'
  import { requestLogin } from '../api/api';

  export default {
    data() {
      return {
        myimg: require('./img/1.jpg'),
        msg: '',
        texts: '滑动验证',
        radio: 3,
        logining: false,
        loginForm: {
          phone: '',
          password: ''
        },
        rules2: {
          phone: [
            { required: true, message: '请输入手机号', trigger: 'blur' },
          ],
          password: [
            { required: true, message: '请输入密码', trigger: 'blur' },
          ]
        },
        checked: true,
        loginLoading: false,
      };
    },
    created(){
      this.getCookie();
    },

    mounted() {
       document.querySelector(".dnnCloud-login-box").style.backgroundImage = "url(./static/img/bg_login.png)";
    },
    
    methods: {
      checkTencentCaptcha(ticket,randstr,appid){
        var ip = returnCitySN["cip"];
        let param = {
          Ticket:ticket,
          Randstr:randstr,
          UserIP:ip,
        }
        API__login.CheckTencentCaptcha(param)
        .then((res) =>{
          if(res.data.code == API__code.SUCCESS){
            this.handleSubmit2();
          }
        });
      },
      
      
      handleSubmit2(formName) {
        var _this = this;
        this.$refs.loginForm.validate((valid) => {
          if (valid) {
            // var captcha1 = new TencentCaptcha('2014410046', function(res) {
            //   /* callback */
            //   if(res.ret === 0){
            //     _this.login();
            //   }
            // });
            // captcha1.show();
             _this.login();
         
          } else {
            this.$message.error('请正确输入登录账号和密码');
            return false;
          }
        });
      },

      // 登录
      login() {
        this.loginLoading = true;
        let param ={
          password:this.loginForm.password,
          user:this.loginForm.phone,
        }
        API__login.loginAdmin(param)
        .then( (res) => {
          if( res.data.code == API__code.SUCCESS ) {
            sessionStorage.removeItem('user');
            sessionStorage.clear();
            this.setCookie("dnnyptInfo_admin","dnnyptadmin_checkCode","");
            this.setCookie("dnnyptInfo_admin","dnnyptadmin_id","");
            this.clearCookie();
            
            this.$message({
              message: '登录成功',
              type: 'success'
            });
            let data = res.data.data;
            var id = res.data.data.id;
            sessionStorage.setItem('dnnypt_id', id);
            
            if(res.data.data.checkCode){
              var checkCode = res.data.data.checkCode
              this.setCookie("dnnyptInfo_admin","dnnyptadmin_checkCode",checkCode);
            }
            if(res.data.data.id){
              var id = res.data.data.id;
              this.setCookie("dnnyptInfo_admin","dnnyptadmin_id",id);
            }
            if(res.data.data.phone){
              var token = res.data.data.phone;
              this.setCookie("dnnyptInfo_admin","dnnyptadmin_token",token);
              this.$store.commit('set__token', token);
            }
            if(res.data.data.name){
              var name = res.data.data.name;
              sessionStorage.setItem('user', name);
            }
            if(res.data.data.type){
              var type = res.data.data.type;
              sessionStorage.setItem('type', type);
            }

            this.$store.commit('set__userinfo',data);
            
          // 客户经理默认访问个人产品
          res.data.data.type == '2'||res.data.data.type == '3'||res.data.data.type == '4'? ( this.$router.push({path: 'authorizeList'})) :  this.$router.push({path: 'management'});
    
            
          }else {
            this.$message.error(res.data.message);
          }
          this.loginLoading = false;
        }).catch( e => {
          this.$message.error('服务器异常，请您稍后再试..');
          this.loginLoading = false;
        });
      },
      
      //设置cookie
      setCookie(c_name, c_pwd, exdays) {
        var exdate = new Date(); //获取时间
        exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays); //保存的天数
        if(c_name == "dnnyptInfo_admin"){
          window.document.cookie = c_pwd + "=" + exdays + ";path=/;expires=" + exdate.toGMTString();
        }else{
          //字符串拼接cookie
          window.document.cookie = "name" + "=" + c_name + ";path=/;expires=" + exdate.toGMTString();
          window.document.cookie = "password" + "=" + c_pwd + ";path=/;expires=" + exdate.toGMTString();
        }
      },

      //读取cookie
      getCookie: function() {
          if (document.cookie.length > 0) {
              var arr = document.cookie.split('; '); //这里显示的格式需要切割一下自己可输出看下
              for (var i = 0; i < arr.length; i++) {
                  var arr2 = arr[i].split('='); //再次切割
                  //判断查找相对应的值
                  if (arr2[0] == 'name') {
                      this.loginForm.name = arr2[1]; //保存到保存数据的地方
                  } else if (arr2[0] == 'password') {
                      this.loginForm.password = arr2[1];
                  }
              }
          }
      },

      //清除cookie
      clearCookie: function() {
          this.setCookie("", "", -1); //修改2值都为空，天数为负1天就好了
      },
    }
  }

</script>

<style lang="scss">
  .dnnCloud-login-box {    
      position: relative;
      width: 100%;
      height: 100%;
      // background:  url('/static/img/bg_login.png');
      background-size: cover;
      background-repeat: no-repeat;
      background-position: left top;

    .login-container {
      position: absolute;
      top: 50%;
      left: 50%;
      -webkit-transform: translate(-50%, -50%);
      -moz-transform: translate(-50%, -50%);
      -ms-transform: translate(-50%, -50%);
      -o-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
      -webkit-border-radius: 8px;
      border-radius: 8px;
      -moz-border-radius: 8px;
      background-clip: padding-box;
      width: 350px;
      padding: 35px 50px 35px 50px;
      background: #fff;
      .title {
        margin-bottom: 20px;
        color: #333;
        font-size: 24px;
        font-weight: normal;
      }
      .iconfont {
         color: #9C9C9C;
      }
      .icon-dianhua {
        font-size: 18px;
        top: 3px;
       
      }
      .remember {
        margin: 0px 0px 35px 0px;
        color:#fff;
      }
    }


    .gradual {
      margin-top: 10px;
      border: none;
    }

    .link {
      float: right;
      padding-top: 5px;
      font-size: 16px;
      color: #F66B3D;
      text-decoration: none;
      &:hover {
        opacity: .8;
      }
    }
     :root {
      --animate-duration: .5s;                           
    }
    
    > img {
      position: absolute;
      z-index: 100;
      transition: all  .5s;
      cursor: pointer;
      &.icon-dm {
        width: 5.36%;
        left: 19.58%;
        top: 41.57%;
        // --animate-duration: 1s;  
        animation-name: fadeInLeft ;
        &:hover {
          left: 19.08%;
        }
      }

      &.icon-jyjj {
        width: 6.98%;
        left: 7.9%;
        top: 73.61%;
        animation-name: fadeInLeft ;
        animation-delay: .2s;
        &:hover {
          left: 7.4%;
        }
      }

      &.icon-erzy {
         width: 8.31%;
         right: 2.55%;
         top: 5.83%;
         animation-name: rotateIn;
         animation-delay: 1s;
        &:hover {
          right: 2.05%;
        }
      }

      &.icon-erbz {
        width: 7.08%;
        right: 21.09%;
        top: 30.287%;
         animation-name: fadeInRight;
         animation-delay: .4s;
         &:hover {
          right: 21.59%;
        }
      }

      &.icon-erdl {
        width: 5.83%;
        right: 7.14%;
        top: 50.56%;
        animation-name: fadeInRight;
        animation-delay: .6s;
        &:hover {
          right: 7.64%;
        }
      }
      
      &.icon-erlj {
        width: 6.30%;
        right: 22.24%;
        top: 74.54%;
        animation-name: fadeIn;  
        --animate-duration: .8s;  
        animation-delay: 1s;
         &:hover {
          top: 75.04%;
        }
      }

    }

    .ft-copyright {
        position:absolute;
        left:0;
        bottom:0;
        width: 100%;
        height: 60px;
        padding-top: 10px;
        text-align: center;
        font-size: 14px;
        line-height: 1.5;
        color: #fff;
        > p {
          margin: 0;
        }
    }

   
  }

</style>


// WEBPACK FOOTER //
// LoginAdmin.vue?58d20c80